import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

export const mentorSections = [
  {
    key: 'devotees',
    labelKey: 'mentor.workspace.sections.devotees.title',
    descriptionKey: 'mentor.workspace.sections.devotees.description',
    icon: PersonRoundedIcon,
  },
  {
    key: 'all-devotees',
    labelKey: 'mentor.workspace.sections.allDevotees.title',
    descriptionKey: 'mentor.workspace.sections.allDevotees.description',
    icon: PeopleRoundedIcon,
  },
  {
    key: 'batches',
    labelKey: 'mentor.workspace.sections.batches.title',
    descriptionKey: 'mentor.workspace.sections.batches.description',
    icon: GroupsRoundedIcon,
  },
  {
    key: 'applications',
    labelKey: 'mentor.workspace.sections.applications.title',
    descriptionKey: 'mentor.workspace.sections.applications.description',
    icon: PendingActionsRoundedIcon,
  },
  {
    key: 'insights',
    labelKey: 'mentor.workspace.sections.insights.title',
    descriptionKey: 'mentor.workspace.sections.insights.description',
    icon: TimelineRoundedIcon,
  },
  {
    key: 'services',
    labelKey: 'mentor.workspace.sections.services.title',
    descriptionKey: 'mentor.workspace.sections.services.description',
    icon: AssignmentRoundedIcon,
  },
] as const;

export type MentorSectionKey = (typeof mentorSections)[number]['key'];

export const isMentorSectionKey = (value: string | undefined): value is MentorSectionKey =>
  Boolean(value) && mentorSections.some((section) => section.key === value);

export type MentorRouteKey = MentorSectionKey | 'overview';

export const isMentorRouteKey = (value: string | undefined): value is MentorRouteKey =>
  value === 'overview' || isMentorSectionKey(value);
